module.exports = __webpack_public_path__ + "img/click.88f8b4a7.svg";